import React from 'react';
import { Transition } from 'react-spring/renderprops';
import { springConfig } from '@99designs/apps/spa/common/utils/spring/spring';
import { IconButton } from '@99designs/frontend-components/components/IconButton';
import { getComponentClasses } from '@99designs/frontend-components/utils/app';
import { IconX1 } from '@99designs/icons';
import { DetachedOverlay } from './DetachedOverlay';

interface Props {
    showing: boolean;
    variations?: ['wide' | 'center'];
    onClose?: () => void;
    background?: React.ReactNode;
    children: React.ReactNode;
}

interface State {
    animating: boolean;
}

export class DrawerOverlay extends React.Component<Props, State> {
    state = {
        animating: true,
    };

    static getDerivedStateFromProps(nextProps: Props) {
        // This ensures that when closing the overlay the background is showing while the animation
        // runs.
        if (nextProps.showing === false) {
            return { animating: true };
        }
        return {};
    }

    render() {
        return (
            <Transition
                items={this.props.showing}
                from={{ transform: 'translate(0,100vh)' }}
                enter={{ transform: 'translate(0,0px)' }}
                leave={{ transform: 'translate(0,100vh)' }}
                config={springConfig(300)}
                onRest={() => this.setState({ animating: false })}
            >
                {(showing) => (props) =>
                    showing && (
                        <DetachedOverlay isAnimating={this.state.animating}>
                            <div
                                className={getComponentClasses(
                                    'drawer-overlay',
                                    this.props.variations
                                )}
                                style={{ ...props }}
                                data-testid="drawer-overlay"
                            >
                                {this.props.onClose && (
                                    <div className="drawer-overlay__close">
                                        <IconButton
                                            onClick={this.props.onClose}
                                            aria-label={__('Dismiss')}
                                        >
                                            <div className="drawer-overlay__close__icon">
                                                <IconX1 />
                                            </div>
                                        </IconButton>
                                    </div>
                                )}
                                {this.props.background}
                                <div className="drawer-overlay__content">{this.props.children}</div>
                            </div>
                        </DetachedOverlay>
                    )}
            </Transition>
        );
    }
}
